import { ExpertPresenceStatus } from '#src/generated/graphql'

interface ExpertPresent {
  expertPresence: {
    status: ExpertPresenceStatus
  }
}

export function isExpertPresent(expert: ExpertPresent) {
  const presentStates = [ExpertPresenceStatus.ON_CALL, ExpertPresenceStatus.ON_SHIFT]

  return presentStates.includes(expert.expertPresence.status)
}
